import { useSelector, useDispatch } from "react-redux";
import { currentSelectedLanguage, RSHIELD_WHEN_LIMIT_REACHED, FOCUS_LOSS_COMBINED_TYPE, splitFocusLossValue } from "../../../../StateManagement/actions";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import APIRequest from "../../../../Services/commonAPIConsumer";
import LoadingSpinner from "../../../Controls/Spinner/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import parse from 'html-react-parser';
import he from "he";

const tabMap = {
  Personal: "personalTab",
  Company: "companyTab",
  Admin: "AdminTab",
};

export function SettingHistory({
  settingId,
  type,
  level,
  label,
  companyLevel,
  closeModal,
}) {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const lookUpData = useSelector((state) => state.settings.lookupData);
  const settings = useSelector((state) => state.settings);
  const timeZoneOffset = useSelector((state) => state.timeZone.timeZoneOffset);
  const tabKey =
    tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];
  const [modalForSettingHistory, setmodalForSettingHistory] = useState(false);
  const [lstSettingHistoryDetails, setlstSettingHistoryDetails] =
    useState(null);
  const [Controltype, setControltype] = useState("");
  const [openLoader, setOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [DynamicheaderText, setDynamicheaderText] = useState("");
  const isDatetimeControl = useRef(localStorage.getItem("DateControlFormat"));
  const dateFormatValueOriginal = useRef(localStorage.getItem('DateFormatValueOriginal'))
  //const [isDatetimeControl, setisDatetimeControl] = useState("false");
  //const [dateFormatValueOriginal, setDateFormatValueOriginal] = useState("");
  //const BannedRegionOptions = useRef([]);
  const history = useNavigate();
  // useEffect(() => {
  //   setTimeout(() => {
  //     setAlertMsg("");
  //     setAlertType("");
  //   }, 5000);
  // }, [alertType]);

  const hasFetchedHistoryRef = useRef(false);
  useEffect(() => {
    if (hasFetchedHistoryRef.current) return;
    hasFetchedHistoryRef.current = true;
    handleSettingHistory();
  }, []);

  async function fetchHistoryRecords(endPoint, historyType = type === "FocusLossLimit" ? FOCUS_LOSS_COMBINED_TYPE : type) {
    try {
      setOpen(true);

      let baseUrl = `${process.env.REACT_APP_API}${endPoint}/${settingId}`;

      if (
        endPoint === process.env.REACT_APP_API_GetSettingGatewayHistoryDetails
      ) {
        level = level === "common" ? "CommonSettings" : level;
      }
      const params = new URLSearchParams({ level, type: historyType });
      baseUrl = `${baseUrl}?${params.toString()}`;

      const jsonDoc = await APIRequest.GET("", baseUrl);

      if (jsonDoc && jsonDoc === "Server maintenance") {
        history("/maintenance");
        return;
      }
      if (jsonDoc.settingHistoryDetails != null) {
        return jsonDoc;
      }
      return null;
    } catch (error) {
      setOpen(false);
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_FailedtoLoadSettingHistory
      );
      setAlertType("warning");
      return null;
    }
  }
  function applyTimeZoneToDisplay(date, offsetString) {
    if (!date || !offsetString) return date;
    const offsetMinutes = timeZoneConverter({
      mode: "parseOffset",
      offsetString
    });
    let adjustedDate;
    if (offsetMinutes > 0) {
      adjustedDate = new Date(date.getTime() + offsetMinutes * 60000);
    } else {
      adjustedDate = new Date(date.getTime() + offsetMinutes * 60000);
    }
    return adjustedDate;
  }

  function timeZoneConverter({
    mode,            // "parseOffset" | "utcToLocal" | "localToFinal" | "finalToUtc"
    value,           // string (UTC) or Date object
    offsetString,    // "+05:30"
  }) {
    // --- Parse offset (always needed) ---
    let offsetMinutes = 0;
    if (offsetString) {
      const m = offsetString.match(/([+-])(\d{2}):(\d{2})/);
      if (m) {
        const sign = m[1] === "-" ? -1 : 1;
        const hh = parseInt(m[2], 10);
        const mm = parseInt(m[3], 10);
        offsetMinutes = sign * (hh * 60 + mm);
      }
    }

    if (mode === "parseOffset") return offsetMinutes;
    if (mode === "utcToLocal") {
      if (!value) return "";
      const utcDate = new Date(value);
      return new Date(utcDate.getTime() + offsetMinutes * 60000);
    }
    if (mode === "localToFinal") {
      if (!value) return "";
      const localDate = value; // Date object
      return new Date(localDate.getTime() - offsetMinutes * 60000);
    }
    if (mode === "finalToUtc") {
      if (!value) return "";
      const finalLocal = value; // Date object
      return new Date(finalLocal.getTime() + offsetMinutes * 60000).toISOString();
    }

    return "";
  }
  async function handleSettingHistory() {
    try {
      if (settingId !== "") {
        setOpen(true);
        let endPoint = "";
        if (
          settings[tabKey]?.selectedTab === "DirectSendDefaults"
        ) {
          endPoint = process.env.REACT_APP_API_GetSettingGatewayHistoryDetails;
        }
        else if (
          settings[tabKey]?.selectedTab === "ContentSecurity"
        ) {
          endPoint = process.env.REACT_APP_API_GetContentSecurityHistoryDetails;
        }
        else {
          endPoint = process.env.REACT_APP_API_GetSettingHistoryDetails;
        }

        const jsonDoc = await fetchHistoryRecords(endPoint);

        if (jsonDoc && jsonDoc === "Server maintenance") {
          history("/maintenance");
          return;
        }



        jsonDoc.settingHistoryDetails != null &&
          jsonDoc.settingHistoryDetails.historyDetails.map((item) => {
            if (
              jsonDoc.settingHistoryDetails.type === "GatewayAccessControl" ||
              jsonDoc.settingHistoryDetails.type === "AccessControl"
            ) {
              if (item.previousData.keyValue.toLowerCase() === "l1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_TrackViews;
              if (item.previousData.keyValue.toLowerCase() === "l2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_TrackReaders;
              if (item.previousData.keyValue.toLowerCase() == "l3")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_LimitReaders;
              if (item.updatedData.keyValue.toLowerCase() == "l1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_TrackViews;
              if (item.updatedData.keyValue.toLowerCase() == "l2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_TrackReaders;
              if (item.updatedData.keyValue.toLowerCase() == "l3")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_LimitReaders;
            }
            if (jsonDoc.settingHistoryDetails.type === "Gateway") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue = selectedLanguage.LstLanguageCodes.UI_OnlyApplyHeadersintheEmail;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_ApplyHeadersintheEmailandDirectSendDefaults;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue = selectedLanguage.LstLanguageCodes.UI_OnlyApplyDirectSendDefaults;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue = selectedLanguage.LstLanguageCodes.UI_OnlyApplyHeadersintheEmail;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_ApplyHeadersintheEmailandDirectSendDefaults;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue = selectedLanguage.LstLanguageCodes.UI_OnlyApplyDirectSendDefaults;
            }
            if (jsonDoc.settingHistoryDetails.type === "TimeZone") {
              item.previousData.keyValue = item.previousData.keyValue && item.previousData.keyValue.split('_')[0];
              item.updatedData.keyValue = item.updatedData.keyValue && item.updatedData.keyValue.split('_')[0];
            }
            if (jsonDoc.settingHistoryDetails.type === "Watermark") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_None;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Confidential;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Draft;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_None;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Confidential;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Draft;
            }
            if (jsonDoc.settingHistoryDetails.type === "CipherText" || jsonDoc.settingHistoryDetails.type === "FloatingText") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_EmailAdressCaps;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherTextDocID;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_EmailAdressAndDocId;
              if (item.previousData.keyValue == "3")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_EncryptedCipher;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_EmailAdressCaps;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherTextDocID;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_EmailAdressAndDocId;
              if (item.updatedData.keyValue == "3")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_EncryptedCipher;
            }
            if (jsonDoc.settingHistoryDetails.type === "CipherView") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherViewLowDense;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherViewMediumDense;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherViewHighDense;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherViewLowDense;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherViewMediumDense;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherViewHighDense;
            }
            if (jsonDoc.settingHistoryDetails.type === "CipherPattern") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherPatternDiffFontSize;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherPatternDiffFontColor;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherPatternDiffFontShape;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherPatternDiffFontSize;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherPatternDiffFontColor;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherPatternDiffFontShape;
            }
            if (jsonDoc.settingHistoryDetails.type === "Shape") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherShapeNone;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherShapeStart;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherShapePolygon;
              if (item.previousData.keyValue == "3")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Both;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherShapeNone;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherShapeStart;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_CipherShapePolygon;
              if (item.updatedData.keyValue == "3")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Both;
            }
            if (jsonDoc.settingHistoryDetails.type === FOCUS_LOSS_COMBINED_TYPE) {
              const previousSplit = splitFocusLossValue(item.previousData.keyValue);
              const updatedSplit = splitFocusLossValue(item.updatedData.keyValue);
              const previousEnabled = previousSplit.enabled === "true";
              const updatedEnabled = updatedSplit.enabled === "true";
              const previousStatus = previousEnabled ? selectedLanguage.LstLanguageCodes.UI_Checked : selectedLanguage.LstLanguageCodes.UI_Unchecked;
              const updatedStatus = updatedEnabled ? selectedLanguage.LstLanguageCodes.UI_Checked : selectedLanguage.LstLanguageCodes.UI_Unchecked;
              const previousLimit = getKeyValue(previousSplit.limit, lookUpData?.FocusOffLimitOptions);
              const updatedLimit = getKeyValue(updatedSplit.limit, lookUpData?.FocusOffLimitOptions);
              item.previousData.keyValue = previousEnabled ? `${previousStatus}${previousLimit ? ` - ${previousLimit}` : ""}` : previousStatus;
              item.updatedData.keyValue = updatedEnabled ? `${updatedStatus}${updatedLimit ? ` - ${updatedLimit}` : ""}` : updatedStatus;
            }

            if (jsonDoc.settingHistoryDetails.type === "WhenLimitisReached") {
              const mapWhenLimitReached = (key) => {
                const fromLookup = getKeyValue(key, lookUpData?.WhenLimitisReachedOptions);
                if (fromLookup !== key && fromLookup) return fromLookup;
                if (key === RSHIELD_WHEN_LIMIT_REACHED.END_SESSION)
                  return selectedLanguage.LstLanguageCodes.UI_EndSession || "End Session";
                if (key === RSHIELD_WHEN_LIMIT_REACHED.REAUTHENTICATE)
                  return selectedLanguage.LstLanguageCodes.UI_Reauthenticate || "Reauthenticate";
                return key;
              };
              item.previousData.keyValue = mapWhenLimitReached(item.previousData.keyValue);
              item.updatedData.keyValue = mapWhenLimitReached(item.updatedData.keyValue);
            }
            if (jsonDoc.settingHistoryDetails.type === "SuffixPrefixFloatingText") {
              const [value, suffix] = item.previousData.keyValue.split("-");
              if (suffix == "0") {
                const displayValue = value ? ` - ${value}` : '';
                item.previousData.keyValue = `${selectedLanguage.LstLanguageCodes.UI_Suffix}${displayValue}`;
              }
              if (suffix == "1") {
                const displayValue = value ? ` - ${value}` : '';
                item.previousData.keyValue = `${selectedLanguage.LstLanguageCodes.UI_Prefix}${displayValue}`;
              }
              const [valueUpdated, suffixUpdated] = item.updatedData.keyValue.split("-");
              if (suffixUpdated == "0") {
                const displayValue = valueUpdated ? ` - ${valueUpdated}` : '';
                item.updatedData.keyValue = `${selectedLanguage.LstLanguageCodes.UI_Suffix}${displayValue}`;
              }
              if (suffixUpdated == "1") {
                const displayValue = valueUpdated ? ` - ${valueUpdated}` : '';
                item.updatedData.keyValue = `${selectedLanguage.LstLanguageCodes.UI_Prefix}${displayValue}`;
              }
            }
            if (jsonDoc.settingHistoryDetails.type === "Opacity") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity10;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity20;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity30;
              if (item.previousData.keyValue == "3")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity40;
              if (item.previousData.keyValue == "4")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity50;
              if (item.previousData.keyValue == "5")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity60;
              if (item.previousData.keyValue == "6")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity70;
              if (item.previousData.keyValue == "7")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity80;
              if (item.previousData.keyValue == "8")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity90;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity10;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity20;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity30;
              if (item.updatedData.keyValue == "3")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity40;
              if (item.updatedData.keyValue == "4")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity50;
              if (item.updatedData.keyValue == "5")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity60;
              if (item.updatedData.keyValue == "6")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity70;
              if (item.updatedData.keyValue == "7")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity80;
              if (item.updatedData.keyValue == "8")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Opacity90;
            }
            if (jsonDoc.settingHistoryDetails.type === "Navigation") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_NavigationTLBR;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_NavigationTRBL;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_NavigationTLBR;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_NavigationTRBL;
            }
            if (jsonDoc.settingHistoryDetails.type === "FontColor") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontColorRed;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontColorGreen;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontColorBlue;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontColorRed;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontColorGreen;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontColorBlue;
            }
            if (jsonDoc.settingHistoryDetails.type === "FontSize") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontSizeSmall;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontSizeMedium;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontSizeLarge;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontSizeSmall;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontSizeMedium;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_FontSizeLarge;
            }
            if (jsonDoc.settingHistoryDetails.type === "Speed") {
              if (item.previousData.keyValue == "0")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Speed05;
              if (item.previousData.keyValue == "1")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Speed1;
              if (item.previousData.keyValue == "2")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Speed15;
              if (item.updatedData.keyValue == "0")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Speed05;
              if (item.updatedData.keyValue == "1")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Speed1;
              if (item.updatedData.keyValue == "2")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Speed15;
            }

            if (jsonDoc.settingHistoryDetails.type === "Launches") {
              if (item.previousData.keyValue == "0") {
                item.previousData.keyValue = "Current time in UTC";
              } else {
                item.previousData.keyValue =
                  item.previousData.keyValue + " " + "Day(s)";
              }
              if (item.updatedData.keyValue == "0") {
                item.updatedData.keyValue = "Current time in UTC";
              } else {
                item.updatedData.keyValue =
                  item.updatedData.keyValue + " " + "Day(s)";
              }
            }
            if (jsonDoc.settingHistoryDetails.type === "LandingPage") {
              if (item.previousData.keyValue === "Send")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Send;
              if (item.previousData.keyValue === "Generate")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Create;
              if (item.previousData.keyValue === "Manage_All Items")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Manage + "_" + selectedLanguage.LstLanguageCodes.UI_AllItems;
              if (item.previousData.keyValue === "Manage_Folder View")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Manage + "_" + selectedLanguage.LstLanguageCodes.UI_FolderView;
              if (item.previousData.keyValue === "Manage_Access Management")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Manage + "_" + selectedLanguage.LstLanguageCodes.UI_AccessManagement;
              if (item.previousData.keyValue === "Settings")
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Settings;
              if (item.updatedData.keyValue === "Send")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Send;
              if (item.updatedData.keyValue === "Generate")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Create;
              if (item.updatedData.keyValue === "Manage_All Items")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Manage + "_" + selectedLanguage.LstLanguageCodes.UI_AllItems;
              if (item.updatedData.keyValue === "Manage_Folder View")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Manage + "_" + selectedLanguage.LstLanguageCodes.UI_FolderView;
              if (item.updatedData.keyValue === "Manage_Access Management")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Manage + "_" + selectedLanguage.LstLanguageCodes.UI_AccessManagement;
              if (item.updatedData.keyValue === "Settings")
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Settings;
            }

            if (
              jsonDoc.settingHistoryDetails.type === "TrackKilledDocuments" ||
              jsonDoc.settingHistoryDetails.type === "TrackKilledDocument" ||
              jsonDoc.settingHistoryDetails.type === "SecureSend" ||
              jsonDoc.settingHistoryDetails.type === "MandatoryDescription" ||
              jsonDoc.settingHistoryDetails.type === "PageLevelRestrictions" ||
              jsonDoc.settingHistoryDetails.type === "SMSAuthentication" ||
              jsonDoc.settingHistoryDetails.type === "ContentSecurity" ||
              jsonDoc.settingHistoryDetails.type === "DirectSendDefaults" ||
              jsonDoc.settingHistoryDetails.type === "IDLeakers" ||
              jsonDoc.settingHistoryDetails.type === "DateControlFormat" ||
              jsonDoc.settingHistoryDetails.type === "RShield" ||
              jsonDoc.settingHistoryDetails.type === "ExcelSupport" ||
              jsonDoc.settingHistoryDetails.type === "RPDLite"
              //jsonDoc.settingHistoryDetails.type === "EDisclosure"||
              // || jsonDoc.settingHistoryDetails.type == "WhatsAppAuthentication"
            ) {
              if (item.previousData.keyValue == "true") {
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Enabled;
              } else {
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Disabled;
              }
              if (item.updatedData.keyValue == "true") {
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Enabled;
              } else {
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Disabled;
              }
            }
            if (jsonDoc.settingHistoryDetails.type.toLowerCase() === "Identifyleakers".toLowerCase() ||
              jsonDoc.settingHistoryDetails.type === "AllowResponsesTo" ||
              jsonDoc.settingHistoryDetails.type === "AllowResponseTo" ||
              jsonDoc.settingHistoryDetails.type === "SendVerificationCode" ||
              jsonDoc.settingHistoryDetails.type === "ProofOfSending" ||
              jsonDoc.settingHistoryDetails.type === "ShareVotes" ||
              jsonDoc.settingHistoryDetails.type === "Voting" ||
              jsonDoc.settingHistoryDetails.type === "NotificationOfReading" ||
              jsonDoc.settingHistoryDetails.type === "DisplayDistributionList" ||
              jsonDoc.settingHistoryDetails.type === "CanPrint" ||
              jsonDoc.settingHistoryDetails.type === "Timestamp" ||
              jsonDoc.settingHistoryDetails.type === "FocusProtection" ||
              jsonDoc.settingHistoryDetails.type === "ResumeOnFullScreen" ||
              jsonDoc.settingHistoryDetails.type === "BanReader" ||
              jsonDoc.settingHistoryDetails.type === "NotifySender"

            ) {
              const isDirectSend = settings[tabKey]?.selectedTab === "DirectSendDefaults"
              if (item.previousData.keyValue == "true") {
                item.previousData.keyValue =
                  (!isDirectSend) ? selectedLanguage.LstLanguageCodes.UI_Checked : selectedLanguage.LstLanguageCodes.UI_Enabled;
              } else {
                item.previousData.keyValue =
                  (!isDirectSend) ? selectedLanguage.LstLanguageCodes.UI_Unchecked : selectedLanguage.LstLanguageCodes.UI_Disabled;
              }
              if (item.updatedData.keyValue == "true") {
                item.updatedData.keyValue =
                  (!isDirectSend) ? selectedLanguage.LstLanguageCodes.UI_Checked : selectedLanguage.LstLanguageCodes.UI_Enabled;
              } else {
                item.updatedData.keyValue =
                  (!isDirectSend) ? selectedLanguage.LstLanguageCodes.UI_Unchecked : selectedLanguage.LstLanguageCodes.UI_Disabled;
              }
            }
            if (jsonDoc.settingHistoryDetails.type === "EDisclosure") {
              if (item.previousData.keyValue == "true") {
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Enabled;
              } else {
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Disabled;
              }
              if (item.updatedData.keyValue == "true") {
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Enabled;
              } else {
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Disabled;
              }
              const getEnabledLevelLabels = (keyCollection) =>
                keyCollection
                  ?.filter(
                    (k) => k.levelFlag === true || k.levelFlag === "true"
                  )
                  .map((k) => {
                    if (k.level === "L1")
                      return selectedLanguage.LstLanguageCodes.UI_TrackViews;
                    if (k.level === "L2")
                      return selectedLanguage.LstLanguageCodes.UI_TrackReaders;
                    if (k.level === "L3")
                      return selectedLanguage.LstLanguageCodes
                        .UI_LimitReaders;
                    return "";
                  })
                  .filter(Boolean)
                  .join(", ") || "";
              if (
                item.previousData.keyValue ===
                selectedLanguage.LstLanguageCodes.UI_Enabled
              ) {
                const previousLevels = getEnabledLevelLabels(
                  item.previousData.keyCollection
                );
                if (previousLevels) {
                  item.previousLevels = previousLevels;
                }
              }
              if (
                item.updatedData.keyValue ===
                selectedLanguage.LstLanguageCodes.UI_Enabled
              ) {
                const updatedLevels = getEnabledLevelLabels(
                  item.updatedData.keyCollection
                );
                if (updatedLevels) {
                  item.updatedLevels = updatedLevels;
                }
              }
            }
            if (jsonDoc.settingHistoryDetails.type === "IPChangeDetection") {
              if (item.previousData.keyValue == "true") {
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Enabled;
              } else {
                item.previousData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Disabled;
              }
              if (item.updatedData.keyValue == "true") {
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Enabled;
              } else {
                item.updatedData.keyValue =
                  selectedLanguage.LstLanguageCodes.UI_Disabled;
              }

              // Responsible for extracting enabled option labels from IPChangeDetectionOptions object (with keyCollection fallback for existing DB history)
              const getEnabledIPLevelLabels = (opts, keyCollection) => {
                const labels = [];
                const o = opts || {};
                const isBan = o.banReader === true || o.BanReader === true ||
                  keyCollection?.some(k => (k.level === "BanReader" || k.Level === "BanReader") && (k.levelFlag === true || k.levelFlag === "true" || k.LevelFlag === true || k.LevelFlag === "true"));
                const isReAuth = o.reAuthenticateReader === true || o.ReAuthenticateReader === true ||
                  keyCollection?.some(k => (k.level === "ReAuthenticateReader" || k.Level === "ReAuthenticateReader") && (k.levelFlag === true || k.levelFlag === "true" || k.LevelFlag === true || k.LevelFlag === "true"));
                const isNotify = o.notifySender === true || o.NotifySender === true ||
                  keyCollection?.some(k => (k.level === "NotifySender" || k.Level === "NotifySender") && (k.levelFlag === true || k.levelFlag === "true" || k.LevelFlag === true || k.LevelFlag === "true"));

                if (isBan) labels.push(selectedLanguage.LstLanguageCodes.UI_BanReader || "Ban Reader");
                if (isReAuth) labels.push(selectedLanguage.LstLanguageCodes.UI_ReAuthenticateReader || "ReAuthenticate Reader");
                if (isNotify) labels.push(selectedLanguage.LstLanguageCodes.UI_NotifySender || "Notify Sender");
                return labels.join(", ");
              };

              if (
                item.previousData.keyValue ===
                selectedLanguage.LstLanguageCodes.UI_Enabled
              ) {
                const previousLevels = getEnabledIPLevelLabels(
                  item.previousData.ipChangeDetectionOptions || item.previousData.IPChangeDetectionOptions,
                  item.previousData.keyCollection
                );
                if (previousLevels) {
                  item.previousLevels = previousLevels;
                }
              }
              if (
                item.updatedData.keyValue ===
                selectedLanguage.LstLanguageCodes.UI_Enabled
              ) {
                const updatedLevels = getEnabledIPLevelLabels(
                  item.updatedData.ipChangeDetectionOptions || item.updatedData.IPChangeDetectionOptions,
                  item.updatedData.keyCollection
                );
                if (updatedLevels) {
                  item.updatedLevels = updatedLevels;
                }
              }
            }
            if (jsonDoc.settingHistoryDetails.type == "AllowedIP") {
              item.previousData.keyValue = item.previousData.keyValue.replace(
                /[{}]/g,
                ""
              );
              item.updatedData.keyValue = item.updatedData.keyValue.replace(
                /[{}]/g,
                ""
              );
            }
            if (jsonDoc.settingHistoryDetails.type == "BannedRegions") {
              var optinUpdatelist = [];
              var optinPrevlist = [];
              var regionUpdateval = "";
              var regionPrevval = "";
              var str = item.previousData.keyValue.replace(/[{}]/g, "");
              str.split(",").map((items, i) => {
                lookUpData?.bannedRegionOptions?.filter((option) => {
                  if (option.value === items) {
                    optinPrevlist.push(option);
                  }
                });
              });
              var uniquePreviousArray = Array.from(
                new Set(optinPrevlist.map((obj) => obj.value))
              ).map((id) => optinPrevlist.find((obj) => obj.value === id));

              for (let i = 0; i < uniquePreviousArray.length; i++) {
                if (regionPrevval == "")
                  regionPrevval = uniquePreviousArray[i].label;
                else if (regionPrevval != "") {
                  regionPrevval =
                    regionPrevval + ", " + uniquePreviousArray[i].label;
                }
              }
              item.previousData.keyValue = regionPrevval;
              var str = item.updatedData.keyValue.replace(/[{}]/g, "");
              str.split(",").map((items, i) => {
                lookUpData?.bannedRegionOptions?.filter((option) => {
                  if (option.value == items) {
                    optinUpdatelist.push(option);
                  }
                });
              });
              var uniqueUpdateArray = Array.from(
                new Set(optinUpdatelist.map((obj) => obj.value))
              ).map((id) => optinUpdatelist.find((obj) => obj.value === id));
              for (let i = 0; i < uniqueUpdateArray.length; i++) {
                if (regionUpdateval == "")
                  regionUpdateval = uniqueUpdateArray[i].label;
                else if (regionUpdateval != "") {
                  regionUpdateval =
                    regionUpdateval + ", " + uniqueUpdateArray[i].label;
                }
              }
              item.updatedData.keyValue = regionUpdateval;
            }
            if (jsonDoc.settingHistoryDetails.type == "DateFormat") {
              item.previousData.keyValue = getKeyValue(item.previousData.keyValue, lookUpData?.dateFormatOptions);
              item.updatedData.keyValue = getKeyValue(item.updatedData.keyValue, lookUpData?.dateFormatOptions);
            }
            if (jsonDoc.settingHistoryDetails.type == "AppLanguage") {
              item.previousData.keyValue = getKeyValue(item.previousData.keyValue, lookUpData?.appLanguageOptions);
              item.updatedData.keyValue = getKeyValue(item.updatedData.keyValue, lookUpData?.appLanguageOptions);
            }
            if (jsonDoc.settingHistoryDetails.type == "ServiceLanguage") {
              item.previousData.keyValue = getKeyValue(item.previousData.keyValue, lookUpData?.serviceLanguageOptions);
              item.updatedData.keyValue = getKeyValue(item.updatedData.keyValue, lookUpData?.serviceLanguageOptions);
            }
            if (jsonDoc.settingHistoryDetails.type === "TermsOfService") {
              item.previousData.keyValue = parse(
                DOMPurify.sanitize(he.decode(item.previousData.keyValue))
              );
              item.updatedData.keyValue = parse(
                DOMPurify.sanitize(he.decode(item.updatedData.keyValue))
              );
            }
          });
        setlstSettingHistoryDetails(jsonDoc.settingHistoryDetails);
        setOpen(false);
        setmodalForSettingHistory(true);
      } else {
        setlstSettingHistoryDetails(null);
        setOpen(false);
        setmodalForSettingHistory(true);
      }
    } catch (error) {
      setOpen(false);
      setmodalForSettingHistory(false);
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_FailedtoLoadSettingHistory
      );
      setAlertType("warning");
      console.log(error);
    }
  }

  function getKeyValue(key, options) {
    const record = options?.find(
      (data) => data.key?.toLowerCase() === key?.toLowerCase()
    );
    return record?.keyValue || key;
  }

  const handlermodalForSettingHistory = () => {
    closeModal(false);
  };
  return (
    <>
      {openLoader ? <LoadingSpinner /> : null}
      <div className="modalCus Setting-history" id="myModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="card-body pt-1">
              <div
                className="mb-2 mt-3 justify-content-between d-flex"
                style={{ borderBottom: "2px solid #918d8d4d" }}>
                <h5 htmlFor="">
                  <p className="fw-bold">
                    {companyLevel == false
                      ? selectedLanguage.LstLanguageCodes
                        .UI_viewingPersonalsettingshistory
                      : selectedLanguage.LstLanguageCodes
                        .UI_viewingCompanysettingshistory}{" "}
                    {label}
                  </p>
                </h5>
                <button
                  type="button"
                  className="btn btn-outline-danger modalclose download"
                  onClick={(e) => handlermodalForSettingHistory()}>
                  <span className="material-icons font-20">highlight_off</span>
                </button>
              </div>
            </div>
            <div
              className="card-body pt-0"
              style={{
                maxHeight: "450px",
                overflow: "auto",
                overflowX: "hidden",
                display: "block",
                paddingRight: "3px",
                marginTop: "-28px",
                marginRight: "10px",
              }}>
              <div className="table-responsive res-card">
                {lstSettingHistoryDetails != null ? (
                  <table
                    className="table table-bordered tblSettingsHistory "
                    cellPadding="0"
                    cellSpacing="0">
                    <thead className="bg-lightblue">
                      <tr className="">
                        <th colspan="3" className="mainHeaderPrevHistory">
                          {selectedLanguage.LstLanguageCodes.UI_PreviousData}
                        </th>
                        <th colspan="3" className="mainHeaderHistory">
                          {selectedLanguage.LstLanguageCodes.UI_UpdatedData}
                        </th>
                        <th className="" rowspan="2">
                          {selectedLanguage.LstLanguageCodes.UI_UpdatedBy}
                          {/* {selectedLanguage.LstLanguageCodes.UI_UpdatedBy} */}
                        </th>
                        <th className="" rowspan="2">
                          {selectedLanguage.LstLanguageCodes.UI_UpdatedDate}
                        </th>
                      </tr>
                      <tr className="">
                        <th className="">
                          {selectedLanguage.LstLanguageCodes.UI_DefaultSettings}
                        </th>
                        <th className="">
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_OverrideUserSettings
                          }
                        </th>
                        <th className="" style={{ width: '8%' }}>
                          {selectedLanguage.LstLanguageCodes.UI_LockSettings}

                          {/* {selectedLanguage.LstLanguageCodes.UI_UpdatedBy} */}
                        </th>
                        <th className="">
                          {selectedLanguage.LstLanguageCodes.UI_DefaultSettings}
                        </th>
                        <th className="">
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_OverrideUserSettings
                          }
                        </th>
                        <th className="">
                          {selectedLanguage.LstLanguageCodes.UI_LockSettings}

                          {/* {selectedLanguage.LstLanguageCodes.UI_UpdatedBy} */}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* <!-------- First one ---------> */}

                      {lstSettingHistoryDetails &&
                        lstSettingHistoryDetails.historyDetails.length > 0 &&
                        lstSettingHistoryDetails.historyDetails.map(
                          (item, i) => (
                            <tr className="borderrow">
                              <td
                                className="default-padding"
                                style={{
                                  width: "18%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                  wordBreak: "break-word",
                                }}>
                                {item.previousLevels ? (
                                  <>
                                    {item.previousData.keyValue}
                                    <br />({item.previousLevels})
                                  </>
                                ) : (
                                  item.previousData.keyValue
                                )}
                              </td>
                              <td
                                style={{
                                  width: "11%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                }}>
                                {item.previousData.overrideUserSetting == "true"
                                  ? selectedLanguage.LstLanguageCodes.UI_Yes
                                  : selectedLanguage.LstLanguageCodes.UI_No}
                              </td>
                              <td
                                style={{
                                  // width: "19%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                }}>
                                {item.previousData.lockSetting == "true"
                                  ? selectedLanguage.LstLanguageCodes.UI_Yes
                                  : selectedLanguage.LstLanguageCodes.UI_No}
                              </td>
                              <td
                                className="default-padding"
                                style={{
                                  width: "16%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                  wordBreak: "break-word",
                                }}>
                                {" "}
                                {item.updatedLevels ? (
                                  <>
                                    {item.updatedData.keyValue}
                                    <br />({item.updatedLevels})
                                  </>
                                ) : (
                                  item.updatedData.keyValue
                                )}
                              </td>
                              <td
                                style={{
                                  width: "7%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                }}>
                                {item.updatedData.overrideUserSetting == "true"
                                  ? selectedLanguage.LstLanguageCodes.UI_Yes
                                  : selectedLanguage.LstLanguageCodes.UI_No}
                              </td>
                              <td
                                style={{
                                  width: "6%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                }}>
                                {item.updatedData.lockSetting == "true"
                                  ? selectedLanguage.LstLanguageCodes.UI_Yes
                                  : selectedLanguage.LstLanguageCodes.UI_No}
                              </td>
                              <td
                                style={{
                                  width: "10%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                }}>
                                {item.modifiedBy}
                              </td>
                              <td
                                style={{
                                  width: "8%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                  borderRight:
                                    "0.1rem solid rgba(231, 229, 229, 0.44) !important",
                                }}>
                                {isDatetimeControl.current == "true"
                                  ? moment.utc(applyTimeZoneToDisplay(new Date(item.modifiedOn), timeZoneOffset))
                                    .format(
                                      (localStorage.getItem(
                                        "DateFormatValueOriginal"
                                      ) == ""
                                        ? localStorage
                                          .getItem("dateFormat")
                                          .toUpperCase()
                                        : localStorage.getItem(
                                          "DateFormatValueOriginal"
                                        ))
                                    )
                                  : moment.utc(applyTimeZoneToDisplay(new Date(item.modifiedOn), timeZoneOffset))
                                    .format(
                                      localStorage.getItem(
                                        "DateFormatValueOriginal"
                                      ) == ""
                                        ? localStorage
                                          .getItem("dateFormat")
                                          .toUpperCase()
                                        : localStorage.getItem(
                                          "DateFormatValueOriginal"
                                        )
                                    )}
                              </td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </table>
                ) : (
                  <h5 htmlFor="">
                    <p className="lblNotFound">
                      {selectedLanguage.LstLanguageCodes.UI_HistoryUnavailable}
                    </p>
                  </h5>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
